<template>
  <div
    class="video-thumbnail position-relative tw-cursor-pointer tw-overflow-hidden tw-aspect-square"
    :style="style"
  >
    <img
      class="tw-w-full tw-h-full tw-object-cover tw-cursor-pointer"
      :src="fetchedThumbnailBase64 || thumbnailBase64"
      alt="Video thumbnail"
    />

    <span
      class="tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2"
    >
      <i class="fas fa-play-circle tw-text-white tw-text-6xl"></i>
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, onBeforeUnmount } from "vue";

const props = defineProps({
  style: { type: Object, default: () => ({}) },
  thumbnailUrl: { type: String, default: null },
  thumbnailBase64: { type: String, default: null },
});

const fetchedThumbnailBase64 = ref<string | null>(null);

const fetchThumbnail = async () => {
  if (!props.thumbnailUrl) {
    fetchedThumbnailBase64.value = null;
    return;
  }

  try {
    const response = await fetch(props.thumbnailUrl, {
      credentials: "same-origin",
    });

    if (!response.ok) {
      console.error(`Failed to fetch video thumbnail: ${response.statusText}`);
      fetchedThumbnailBase64.value = null;
      return;
    }

    const data = await response.json();

    if (data?.image) {
      fetchedThumbnailBase64.value = data.image;
    } else {
      console.warn("No image found in response");
      fetchedThumbnailBase64.value = null;
    }
  } catch (error) {
    console.error("Failed to fetch video thumbnail:", error);
    fetchedThumbnailBase64.value = null;
  }
};

onMounted(() => {
  fetchThumbnail();
});

watch(
  () => props.thumbnailUrl,
  (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
      fetchThumbnail();
    }
  },
);

onBeforeUnmount(() => {
  fetchedThumbnailBase64.value = null;
});
</script>
